import {fetch} from 'utils/dataAccess';

/**
 * GET /shipments/{id}/relay_points
 *
 * Every parameter is optional: without any, the API centres the search on the shipment's current
 * delivery address. Errors (400 invalid location, 502 carrier down) are surfaced as Error(message)
 * instead of redirecting to the global error page.
 */
export default async function searchRelayPoints(shipmentIri, {country, postalCode, city, latitude, longitude, limit} = {}) {
    const params = new URLSearchParams();
    if (country) params.set('country', country);
    if (postalCode) params.set('postalCode', postalCode);
    if (city) params.set('city', city);
    if (latitude !== undefined && latitude !== null && longitude !== undefined && longitude !== null) {
        params.set('latitude', String(latitude));
        params.set('longitude', String(longitude));
    }
    if (limit) params.set('limit', String(limit));

    const query = params.toString();
    const response = await fetch(
        `${shipmentIri}/relay_points${query ? `?${query}` : ''}`,
        {method: 'GET'},
        false,
        true,
    );

    return await response.json();
}
